export const SHOW_NOTIFICATION = 'flowRedesign/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'flowRedesign/HIDE_NOTIFICATION';
